<template>
  <div class="process">
    <div class="process-group">
      <div class="process-step flex-center">
        <div class="process-step-icon">1</div>
        <span class="process-step-name">注册账号</span>
      </div>
      <div class="process-step flex-center">
        <div class="process-step-icon">2</div>
        <span class="process-step-name">资质认证</span>
      </div>
      <div class="process-step flex-center">
        <div class="process-step-icon">3</div>
        <span class="process-step-name">接入应用</span>
      </div>
      <div class="process-step flex-center">
        <div class="process-step-icon">4</div>
        <span class="process-step-name">集成开发</span>
      </div>
    </div>
    <div class="process-btn" @click="handleClick">
      申请入驻
    </div>
  </div>
</template>

<script>
export default {
  name: 'Process',
  data() {
    return {}
  },
  methods: {
    handleClick() {
      this.$emit('handleClick')
    }
  }
}
</script>

<style lang="scss" scoped>
.process {
  border: 2px dashed #cccccc;
  max-width: 1168px;
  width: 100%;
  height: 58px;
  position: relative;
  &-group {
    position: absolute;
    font-size: 16px;
    color: #666666;
    top: -13px;
    display: flex;
    justify-content: space-around;
    width: 100%;
  }
  &-step {
    background: #ffffff;
    width: 150px;
    &-icon {
      border: 1px solid #e7e7e7;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      font-size: 16px;
      line-height: 22px;
      text-align: center;
    }
    &-name {
      margin-left: 8px;
      display: inline;
    }
  }
  &-btn {
    line-height: 44px;
    background-color: #04A2D6;
    color: #ffffff;
    text-align: center;
    font-weight: 600;
    width: 144px;
    height: 44px;
    position: absolute;
    left: 50%;
    bottom: -20px;
    transform: translateX(-50%);
    cursor: pointer;
  }
}
</style>
